export const spotCategoryMapping = {
    'RESTAURANT': 1,
    'BAR': 2,
    'LOUNGE': 3,
    'CLUB': 4,
};
